(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cedar-call-button"] && !Shopify.designMode) return;
  try {
    // See the doc block: the footer's containing block breaks `position: fixed`. Re-parent to <body>.
  (function () {
    function portal() {
      document.querySelectorAll('.cedar-call').forEach(function (el) {
        if (el.parentElement !== document.body) document.body.appendChild(el);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', portal);
    } else {
      portal();
    }
    // Heritage re-renders sections on navigation and in the theme editor; re-run on both.
    document.addEventListener('shopify:section:load', portal);
    document.addEventListener('shopify:block:select', portal);
  })();
  } catch(e) { console.error(e); }
})();

})();
